import KeyedItem from "../base/item";

type Tag = KeyedItem & {
  name: string;
  tagType: TagType;
  userId: string;
};

export enum TagType {
  Tag = "Tag",
  Department = "Department",
}

export default Tag;
